const declaracao_de_conclusao = [
  {
    path: "/declaracao-de-conclusao",
    redirect: "/declaracao_de_conclusao",
    meta: {
      breadCrumb: "Gestão - Emissão de Documentos",
    },
    children: [
      {
        path: "/declaracao-de-conclusao",
        name: "declaracao_de_conclusao",
        component: () =>
          import("@/views/DeclaracaoDeConclusao/DeclaracaoDeConclusao.vue"),
      },
    ],
  },
];

export { declaracao_de_conclusao };
